import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="privacy-content">
        <div className="container">
          <div className="privacy-document">
            <div className="privacy-section">
              <h2>1. Introduction</h2>
              <p>
                Welcome to Tinder. We respect your privacy and want you to understand how we collect, use, and share information about you. This Privacy Policy applies to the Tinder mobile application and website, and describes our practices regarding the collection, use, and disclosure of your information.
              </p>
              <p>
                By using our Services, you agree to the collection and use of information in accordance with this policy. If you do not agree with the terms of this Privacy Policy, please do not access the Services.
              </p>
            </div>

            <div className="privacy-section">
              <h2>2. Information We Collect</h2>
              <p>We collect several types of information from and about users of our Services:</p>
              
              <h3>Information You Provide</h3>
              <ul>
                <li>Account information (name, email address, phone number, date of birth, gender)</li>
                <li>Profile information (photos, bio, interests, education, job)</li>
                <li>Payment information for premium features</li>
                <li>Communications with other users</li>
              </ul>

              <h3>Information We Collect Automatically</h3>
              <ul>
                <li>Device information (type, operating system, identifiers)</li>
                <li>Log data (access times, pages viewed, IP address)</li>
                <li>Location information (with your permission)</li>
                <li>Usage data (how you interact with our Services)</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our Services</li>
                <li>Match you with other users</li>
                <li>Communicate with you about products, services, and events</li>
                <li>Process payments and prevent fraud</li>
                <li>Personalize your experience</li>
                <li>Ensure the safety and security of our users</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>4. Information Sharing</h2>
              <p>We may share your information with:</p>
              <ul>
                <li>Other users according to your privacy settings</li>
                <li>Service providers who perform services on our behalf</li>
                <li>Affiliated companies within our corporate group</li>
                <li>Law enforcement when required by law</li>
                <li>Business partners with your consent</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>5. Your Privacy Rights</h2>
              <p>Depending on your location, you may have the right to:</p>
              <ul>
                <li>Access the personal data we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Data portability</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>6. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </div>

            <div className="privacy-section">
              <h2>7. Cookies and Tracking</h2>
              <p>
                We use cookies, web beacons, and similar technologies to collect information about your activities on our Services. You can control cookies through your browser settings and other tools.
              </p>
            </div>

            <div className="privacy-section">
              <h2>8. Children's Privacy</h2>
              <p>
                Our Services are not intended for children under 18 years of age. We do not knowingly collect personal information from children under 18.
              </p>
            </div>

            <div className="privacy-section">
              <h2>9. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div className="privacy-section">
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> privacy@tinder.com<br />
                <strong>Address:</strong> 8750 N. Central Expressway, Dallas, TX 75231
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
